import {
  IconButton,
  Button,
  Grid,
  Flex,
  Text,
  useDisclosure,
  useColorModeValue,
} from '@chakra-ui/react';
import { CustomChevronLeftIcon } from '../../../theme/icons/CustomChevronLeftIcon';
import InfoDrawer from '../../common/InfoDrawer';
import { Link } from 'react-router-dom';
import MoreInfoLine from '../../common/MoreInfoLine';
import { CustomCsvDownloadIcon } from '../../../theme/icons/CustomCsvDownloadIcon';
import InvoiceStatus from './InvoiceStatus';

function InvoiceMoreInfo({ cell }) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const modeIconColor = useColorModeValue('secondaryDark08', '#DDDDDD');
  const modeBoxBg = useColorModeValue('white', 'secondaryDark');
  const modeTextBg = useColorModeValue('white', 'primaryDark06');
  const modeLabelBg = useColorModeValue('white', 'primaryDark03');
  const modeBorderColor = useColorModeValue('primaryBackground', 'primaryDark');

  function handleMoreInfoClick(e) {
    e.stopPropagation();
    onOpen();
  }

  const bgColors = {
    modeBoxBg,
    modeTextBg,
    modeBorderColor,
    modeLabelBg,
  };

  return (
    <>
      <IconButton
        aria-label="More Info"
        onClick={handleMoreInfoClick}
        icon={
          <CustomChevronLeftIcon
            w="20px"
            h="20px"
            color={modeIconColor}
            transform="rotate(180deg)"
          />
        }
        variant="white"
        size="sm"
        w="36px"
        mr={1}
      />
      <InfoDrawer
        isOpen={isOpen}
        onClose={onClose}
        header="Invoice Overview"
        footer={
          <Flex justifyContent="space-between" alignItems="center" w="full">
            <Link
              color={useColorModeValue('secondaryDark08', '#DDDDDD')}
              fontSize="14px"
              onClick={onClose}
              mr="30px"
            >
              <Text textStyle="headingFamilyMedium">Back to list</Text>
            </Link>
          </Flex>
        }
        bgColors={bgColors}
      >
        <Grid templateColumns={{ base: '150px 1fr', md: '192px 1fr' }} gap={0}>
          <MoreInfoLine
            heading="Month"
            value={cell.row.original.attributes.billingPeriod}
          />
          <MoreInfoLine
            heading="Plan"
            value={`${cell.row.original.attributes.plan}${cell.row.original.attributes.trialPeriodInvoice ? ' - Trial Period' : ''}`}
          />
          <MoreInfoLine
            heading="Status"
            value={
              <InvoiceStatus
                status={
                  !cell.row.original.attributes.trialPeriodInvoice
                    ? cell.row.original.attributes.status
                    : 'trial'
                }
              />
            }
          />
          <MoreInfoLine
            heading="View"
            value={
              <Button
                variant="secondary"
                size="sm"
                px="19px"
                onClick={() => {
                  window.open(
                    cell.row.original.attributes.hostedInvoiceUrl,
                    '_blank'
                  );
                }}
              >
                <Text>View</Text>
              </Button>
            }
          />
          <MoreInfoLine
            heading="Download"
            value={
              <Button
                variant="secondary"
                size="sm"
                px="19px"
                onClick={() => {
                  window.open(
                    cell.row.original.attributes.invoicePdf,
                    '_blank'
                  );
                }}
              >
                <Text>Download</Text>
              </Button>
            }
          />
        </Grid>
      </InfoDrawer>
    </>
  );
}

export default InvoiceMoreInfo;
